import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

import ALink from '~/components/features/custom-link';
import TruncatedTooltip from '~/components/common/truncated-tooltip';
import { awardHref, cardPoints } from '~/utils/productGroup';
import { useStoreCategories, pickRandomCategories } from '~/hooks/useStoreCategories';
import { useAwardSearch } from '~/hooks/useAwardSearch';
import { useProgram } from '~/hooks/useProgram';

// SearchBox del header. El submit redirige a /shop. El selector de categorías
// usa las categorías reales del programa (10 aleatorias, alfabéticas).
// Pendiente: cablear la búsqueda en vivo de productos.
function SearchBox() {
  const router = useRouter();
  const [search, setSearch] = useState('');
  const [cat, setCat] = useState('');

  const { data = [] } = useStoreCategories();
  const searchCategories = useMemo(() => pickRandomCategories(data, 10), [data]);

  const { program } = useProgram();
  const { results, isActive } = useAwardSearch(search);

  useEffect(() => {
    const onBodyClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('.header-search')) {
        const el = target.closest('.header-search') as HTMLElement;
        return el.classList.contains('show-results') || el.classList.add('show-results');
      }

      document.querySelector('.header-search.show') &&
        document.querySelector('.header-search.show')?.classList.remove('show');
      document.querySelector('.header-search.show-results') &&
        document.querySelector('.header-search.show-results')?.classList.remove('show-results');
    };

    document.querySelector('body')?.addEventListener('click', onBodyClick);
    return () => {
      document.querySelector('body')?.removeEventListener('click', onBodyClick);
    };
  }, []);

  useEffect(() => {
    setSearch('');
    setCat('');
  }, [router.query.slug]);

  function onSearchClick(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    (e.currentTarget.parentNode as HTMLElement).classList.toggle('show');
  }

  function onSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSearch(e.target.value);
  }

  function onSubmitSearchForm(e: React.FormEvent) {
    e.preventDefault();
    router.push({
      pathname: '/search',
      query: {
        search: search,
        category: cat,
      },
    });
  }

  return (
    <div className="header-search hs-expanded">
      <a href="#" className="search-toggle" role="button" onClick={onSearchClick}>
        <i className="icon-search-3"></i>
      </a>
      <form action="#" method="get" onSubmit={onSubmitSearchForm} className="input-wrapper">
        <div className="select-box">
          <select name="cat" className="cat" value={cat} onChange={(e) => setCat(e.target.value)}>
            <option value="">Todas</option>
            {searchCategories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <input
          type="text"
          className="form-control"
          name="search"
          autoComplete="off"
          value={search}
          onChange={onSearchChange}
          placeholder="Buscar..."
          required
        />

        <button className="btn btn-search" type="submit">
          <i className="d-icon-search"></i>
        </button>

        {/* Resultados de búsqueda en vivo (debounced). */}
        <div className="live-search-list bg-white" style={{ marginTop: '2px' }}>
          {isActive &&
            results.map((item) => (
              <ALink
                key={item.id}
                href={awardHref(item).href}
                as={awardHref(item).as}
                className="autocomplete-suggestion"
              >
                <img src={item.award.mainImage} width={40} height={40} alt={item.award.name} />
                <TruncatedTooltip>
                  <div className="search-name ml-4">{item.award.name}</div>
                </TruncatedTooltip>
                <span className="search-price">
                  {cardPoints(item).from ? 'Desde ' : ''}
                  {cardPoints(item).points.toLocaleString('es')} {program?.coinName}
                </span>
              </ALink>
            ))}
        </div>
      </form>
    </div>
  );
}

export default SearchBox;
